import React, { VFC } from 'react';

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import { Announcement } from 'mintel-react-ui';

TimeAgo.addDefaultLocale(en);
const timeAgo = new TimeAgo('en-US');

type LongTermPreviewBannerProps = {
  publishedDate: string;
};

const LongTermPreviewBanner: VFC<LongTermPreviewBannerProps> = ({
  publishedDate,
}) => (
  <Announcement
    label="This is a Long Term Preview and is not live!"
    showCloseButton={false}
    mode="warning"
  >
    Updated {timeAgo.format(new Date(publishedDate))}
  </Announcement>
);

export default LongTermPreviewBanner;
